import { addListener } from "@grindex-common/helpers/domManipulation";
import { initializeVideo, isScriptRendered, scriptRender } from "@grindex-client/components/Video/jwplayerVideo.class";

const LARGE_RESOLUTION_BREAK_POINT = 640;
const VIDEO_WIDTH_LARGE_SCREEN = 380;
const VIDEO_WIDTH_SMALL_SCREEN = 180;

function renderForJQuery($targetContainer, $containerDiv) {
	$targetContainer.html($($containerDiv));
}

function renderDefault($targetContainer, $containerDiv) {
	$targetContainer.innerHTML = "";
	$targetContainer.appendChild($containerDiv);
}

const videoRenderer = {
	renderOverlayVideo: function (key, videoKey, $targetContainer) {
		if (!isScriptRendered()) {
			scriptRender(`jwplayer/jwplayer.js`, renderJwplayerVideo);
		} else {
			renderJwplayerVideo();
		}

		function renderJwplayerVideo() {
			const videoPlayerId = videoKey;

			var videoContainer = initializeVideo(key, videoPlayerId);

			if ($targetContainer.html) {
				renderForJQuery($targetContainer, videoContainer);
			} else {
				renderDefault($targetContainer, videoContainer);
			}
		}
	},

	renderModalVideo: function ($element) {
		const $modal = $(".video-modal");
		const key = $element.target.dataset.video;
		const videoPlayerId = $element.target.dataset.videoPlayerId;

		if (key) {
			videoRenderer.renderOverlayVideo(key, videoPlayerId, $modal);
			$modal.modal();
		}
	},

	renderModalYoutubeVideo: function ($element) {
		const $modal = $(".video-modal");
		const key = $element.dataset.video;

		this.iframeTag =
			"<div style='height:380px'><iframe src='//www.youtube.com/embed/{0}' frameborder='0'" +
			"allow='autoplay;encrypted-media' allowfullscreen width='100%' height='100%'></iframe></div>";

		if (key) {
			$modal.empty();
			$modal.append(String.format(this.iframeTag, key));
			$modal.modal();
		} else {
			return;
		}
	},

	renderDefaultVideo: function (e) {
		this.renderVideoWithBreakPoint(e);
	},

	renderVideoWithBreakPoint: function (e) {
		if (window.matchMedia(`(min-width: ${LARGE_RESOLUTION_BREAK_POINT}px)`).matches) {
			jwplayer(e).resize("100%", VIDEO_WIDTH_LARGE_SCREEN);
		} else {
			jwplayer(e).resize("100%", VIDEO_WIDTH_SMALL_SCREEN);
		}
	},

	getThumbnails: function () {
		return document.querySelectorAll(".video-thumb");
	},

	getYoutubeThumbnails: function () {
		return document.querySelectorAll(".video-thumbyoutube");
	},

	getVideoModalLinks: function () {
		return document.querySelectorAll(".video-modal-link");
	},

	init: function () {
		this.getVideoModalLinks().forEach(($thumb) => {
			addListener($thumb, "click", function (event) {
				event.currentTarget.closest(".video-container").querySelector(".video-thumb").dispatchEvent(new Event("click"));
			});
		});

		this.getYoutubeThumbnails().forEach(($thumb) => {
			addListener($thumb, "click", this.renderModalYoutubeVideo);
		});

		this.getThumbnails().forEach(($thumb) => {
			addListener($thumb, "click", this.renderModalVideo);
		});
	},
};

export { videoRenderer };
